export interface INavigation {
    onBackPressed: () => void;
    onNextPressed: () => void;
}

export enum Direction {
    Left,
    Right,
}

export type Form = { [x: string]: any };

export type Upload = { originalFile: string; uploadedFile: string };

export type Body = Form & {
    attachments: Upload[];
    [key: string]: unknown;
};

export type SubmissionStatus = {
    submitted: boolean;
    finished: boolean;
    hasErrors: boolean;
    message: string;
    data: unknown;
};

export interface IStylesProps {
    marginTop?: string;
    marginBottom?: string;
    fontWeight?: number;
    padding?: string;
    border?: string;
}

export type SchoolFromAPI = {
    id: number;
    name: string;
    lat: string;
    lng: string;
    displayInMorcareDropDown: boolean;
    studentCard?: {
        claimSecureNumber?: string;
        iaFinanceGroupNumber?: string;
    };
};

export type School = {
    id: number;
    name: string;
    lat: number;
    lng: number;
    internationalStudents: boolean;
    policyNumber?: string;
    groupNumber?: string;
};
